
import { useEffect, useState, useRef } from 'react';

export default function WhatWeStore() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const weStore = [
    'Email',
    'Password (hashed)',
    'Firm name',
    'Attorney name',
    'Bar number',
    'Billing (via Stripe)',
  ];

  const weNeverStore = [
    'Audio recordings',
    'Transcripts',
    'Document content',
    'Client names',
    'Case info',
    'Opposing counsel',
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#0a0a0c]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="font-harvey-serif text-white text-3xl sm:text-[42px] font-normal tracking-tight text-center mb-16 sm:mb-20">
          What We Store vs Don't
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* We Store */}
          <div
            className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <h3 className="font-harvey-serif text-white text-2xl sm:text-3xl font-normal tracking-tight mb-6 sm:mb-8">
              We Store <span className="font-harvey-sans text-[#a1a1aa] text-lg sm:text-xl font-light">(encrypted)</span>
            </h3>
            <div className="space-y-3 sm:space-y-4">
              {weStore.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-[#06b6d4] text-lg sm:text-xl">✓</span>
                  <span className="font-harvey-sans text-[#d4d4d8] text-base sm:text-lg font-light tracking-wide">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* We Never Store */}
          <div
            className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 delay-200 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <h3 className="font-harvey-serif text-white text-2xl sm:text-3xl font-normal tracking-tight mb-6 sm:mb-8">
              We Never Store
            </h3>
            <div className="space-y-3 sm:space-y-4">
              {weNeverStore.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-red-500 text-lg sm:text-xl">✕</span>
                  <span className="font-harvey-sans text-[#d4d4d8] text-base sm:text-lg font-light tracking-wide">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p
          className={`font-harvey-sans text-[#a1a1aa] text-lg sm:text-xl font-light tracking-wide text-center mt-12 sm:mt-16 transition-all duration-700 delay-400 ${
            animated ? 'opacity-100' : 'opacity-0'
          }`}
        >
          Client data never reaches our database. It passes through and is destroyed
        </p>
      </div>
    </section>
  );
}
